const whoWeServeData = [
  {
    video: "https://player.vimeo.com/video/555593148?h=0698e3b84d",
    tag: "Sports & Fitness",
    logo: "https://s3-eu-west-1.amazonaws.com/merchants.zbooni/media/business_logos/6887EC40-C3B6-4F94-AEF0-B8183006A79D.jpg",
    title: "Basketball Hub",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/555599366?h=69a13eb56d",
    tag: "Professional Services",
    logo: "https://s3-eu-west-1.amazonaws.com/merchants.zbooni/media/business_logos/C8B81F42-B21D-4001-9468-7689D9245FEF.jpg",
    title: "Motorhub",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/555593634?h=ebf941ddb0",
    tag: "Professional Services",
    logo: "https://s3-eu-west-1.amazonaws.com/merchants.zbooni/media/business_logos/2CD1CAE7-A362-430A-BA46-3B607F835ECC.jpg",
    title: "Princess Parties",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/555593272?h=19703c37c6",
    tag: "Food & Beverage",
    logo: "https://s3-eu-west-1.amazonaws.com/merchants.zbooni/media/business_logos/AAEAA1B2-633D-4BC0-8461-C6975C75BE79.jpg",
    title: "Dish Catering and Events LLC",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/544164185?h=e2bed79a4a",
    tag: "eCommerce",
    logo: "https://s3-eu-west-1.amazonaws.com/merchants.zbooni/media/business_logos/CB0E92FB-41BB-426C-B2FE-B0756661454D.jpg",
    title: "Yadawy",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/544164222?h=51121e1996",
    tag: "Sports & Fitness",
    logo: "https://s3-eu-west-1.amazonaws.com/merchants.zbooni/media/business_logos/7F08469A-EB70-4247-ACF3-8867EF6D5FC3.jpg",
    title: "AFC Dubai",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/498843321?h=9d2ccfadfd",
    tag: "Professional Services",
    logo: "https://media.zbooni.shop/assets/web/marketplace/logo/blossom-tree-flower-shop.jpg",
    title: "Blossom Tree Flower Shop",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/498843463?h=13c96086db",
    tag: "Sports & Fitness",
    logo: "https://media.zbooni.shop/assets/web/marketplace/logo/champions-karate.jpg",
    title: "Champions Karate",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/498843552?h=10c3c1255e",
    tag: "Food & Beverage",
    logo: "https://s3-eu-west-1.amazonaws.com/merchants.zbooni/media/business_logos/cropped1564495409485383617.jpg",
    title: "Maitha & Treats",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/498843830?h=5c7c6371c3",
    tag: "Professional Services",
    logo: "https://s3-eu-west-1.amazonaws.com/merchants.zbooni/media/business_logos/avatar_gcSZ9Zd",
    title: "Wear That",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/498843751?h=1e2a7486b6",
    tag: "Sports & Fitness",
    logo: "https://media.zbooni.shop/assets/web/marketplace/logo/super-sup-fit.jpg",
    title: "Super SUP Fit",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/498843515?h=eca137a528",
    tag: "Education & Training",
    logo: "https://s3-eu-west-1.amazonaws.com/merchants.zbooni/media/business_logos/6A99664D-1336-4EC2-B179-8DF336218358.jpg",
    title: "Filipino Institute",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/498843293?h=994eb78b46",
    tag: "Education & Training",
    logo: "https://s3-eu-west-1.amazonaws.com/merchants.zbooni/media/business_logos/cropped7747357650828935983.jpg",
    title: "AIST Royal Educational Center",
    location: "Dubai, UAE",
  },
  {
    video: "https://player.vimeo.com/video/498843229?h=f3dccd1bc0",
    tag: "Food & Beverage",
    logo: "https://s3-eu-west-1.amazonaws.com/merchants.zbooni/media/business_logos/B46EFFD0-1C46-48C9-8231-4C21B8A30191.jpg",
    title: "Aist Cafe",
    location: "Dubai, UAE",
  },
];

export default whoWeServeData;
